import { number, object } from "yup";

export const DftReviewSchema = object({
  taxAmountPayable: number()
    .min(0, "Amount must be 0 or greater")
    .required("This field is required"),
  grossAssetValue: number()
    .min(0, "Amount must be 0 or greater")
    .required("This field is required"),
});
